/**
 * URL Type
 */
export enum UrlType {
  Primary = 'primary',
  Secondary = 'secondary',
}